import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, compose } from 'redux';
import { Provider } from 'react-redux';
import { HashRouter } from 'react-router-dom';

import churgerBuilderReducer from './store/reducers/churgerBuilderReducer';
import './index.css';
import App from './App';

const composeEnhancers =
	process.env.NODE_ENV === 'development'
		? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
		: '' || compose;
const store = createStore(churgerBuilderReducer, composeEnhancers());

// ReactDOM.render(
// 	<Provider store={store}>
// 		<HashRouter>
// 			<App />
// 		</HashRouter>
// 	</Provider>,
// 	document.getElementById('root')
// );
ReactDOM.unstable_createRoot(document.getElementById('root')).render(
	<Provider store={store}>
		<HashRouter>
			<App />
		</HashRouter>
	</Provider>
);

// import React from 'react';
// import ReactDOM from 'react-dom';
// import { createStore } from 'redux';
// import { Provider } from 'react-redux';
// import { HashRouter } from 'react-router-dom';

// import churgerBuilderReducer from './store/reducers/churgerBuilderReducer';
// import './index.css';
// import App from './App';

// const store = createStore(
// 	churgerBuilderReducer,
// 	window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__()
// );

// // ReactDOM.render(
// // 	<React.StrictMode>
// // 		<Provider store={store}>
// // 			<HashRouter>
// // 				<App />
// // 			</HashRouter>
// // 		</Provider>
// // 	</React.StrictMode>,
// // 	document.getElementById('root')
// // );
// ReactDOM.unstable_createRoot(document.getElementById('root')).render(
// 	<React.StrictMode>
// 		<Provider store={store}>
// 			<HashRouter>
// 				<App />
// 			</HashRouter>
// 		</Provider>
// 	</React.StrictMode>
// );
